export enum DeductionInformationLabels {
  DeductionType = "Deduction Type",
  DeductionSubType = "Deduction Sub-Type",
  GLCode = "GL Code",
  DeductedAmount = "Itemized Total",
  TotalAmount = "Claim Amount",
  Purchaser = "Purchaser",
  DC = "Distribution Center",
  DeductionDate = "Deduction Date",
  PONumber = "PO Number",
  Period = "Period",
  Status = "Status",
  Priority = "Priority",
  Validity = "Validity",
  Analyst = "Analyst",
  Approver = "Approver",
  Retailer = "Retailer",
  ReasonCode = "Reason Code",
  Description = "Description",
}
